export default [
  {
    path: '/admin/scales',
    name: 'admin_scales',
    component: () => import('./ScalesAdmin.vue'),
    meta: {
      name: 'Admin - Escala',
    },
  },
]
